import TableBody from "./TableBody";
import TableHead from "./TableHead";
import useTable from '../../context/TableContext';
import { useEffect } from 'preact/hooks';

export default function Table({ id, caption, columns, selectable, data, cellFormat, filter, pagination }) {
    const {
        tableData,
        tableDataDisplay,
        tableActions,
        setTableActions,
        handleFiltering,
        handleDisplaying
    } = useTable();
    let bodyData = data ? data : tableDataDisplay[id];

    if (typeof bodyData == 'undefined' || bodyData === null) {
        return (
            <div class="spinner-border text-warning" role="status" >
                <span class="visually-hidden">Loading table data...</span>
            </div >
        );
    }

    useEffect(() => {
        handleDisplaying(id);
        //if (selectable) document.documentElement.scrollTo(0, sessionStorage.scrollTop || 0);
    }, [tableActions]);

    function handleSelectChange(row_id, accessor) {
        if (!selectable) return;
        if (!selectable.find(column => column == accessor)) return;
        // Save scroll position
        //sessionStorage.scrollTop = document.documentElement.scrollTop;
        let selectedRowsCopy = [];

        if (typeof tableActions[id].selectedRows != 'undefined') {
            selectedRowsCopy = [...tableActions[id].selectedRows];
        }
        if (selectedRowsCopy.includes(row_id)) {
            selectedRowsCopy.splice(selectedRowsCopy.indexOf(row_id), 1);
        } else {
            selectedRowsCopy.push(row_id);
        }
        setTableActions({
            ...tableActions,
            [id]: {
                ...tableActions[id],
                selectedRows: selectedRowsCopy
            }
        });
    }

    const handleSelectAll = () => {
        if (!selectable) return;
        let selectedRowsCopy = [];
        let selectableData = handleFiltering(id, tableData[id]);
        if (typeof tableActions[id].selectedRows != 'undefined') {
            selectedRowsCopy = [...tableActions[id].selectedRows];
        }
        selectableData.map(row => {
            if (!selectedRowsCopy.includes(row.id)) {
                selectedRowsCopy.push(row.id);
            }
            setTableActions({
                ...tableActions,
                [id]: {
                    ...tableActions[id],
                    selectedRows: selectedRowsCopy
                }
            });
        });
    }

    const handleSortingChange = (id, accessor) => {
        const sortOrder =
            accessor === tableActions[id].sortedField && tableActions[id].order === "asc" ? "desc" : "asc";
        setTableActions({
            ...tableActions,
            [id]: {
                ...tableActions[id],
                sortedField: accessor,
                order: sortOrder
            }
        });
    };

    const handlePageChange = (page) => {
        setTableActions({
            ...tableActions,
            [id]: {
                ...tableActions[id],
                pager: {
                    ...tableActions[id].pager,
                    page
                }
            }
        });
    }

    const removeSelection = (event) => {
        // event.stopPropagation();
        // event.stopImmediatePropagation();
        // event.preventDefault();
        setTableActions({
            ...tableActions,
            [id]: {
                ...tableActions[id],
                selectedRows: []
            }
        });
    }

    const tableHeadProps = {
        id,
        columns,
        sortedField: tableActions[id] ? tableActions[id].sortedField : '',
        handleSortingChange,
        order: tableActions[id] ? tableActions[id].order : '',
        filter
    };

    const tableBodyProps = {
        columns,
        handleSelectChange,
        data: bodyData,
        selectedRows: tableActions[id] ? tableActions[id].selectedRows : [],
        selectable,
        cellFormat
    }

    const pages = [];
    // Activate pagination only for interactive table (live actions on the table)
    if (pagination && tableActions[id]) {
        const totalPages = Math.ceil(tableDataDisplay.nbResults[id] / tableActions[id].pager.itemsPerPage);
        if (totalPages > 8) {
            let nbPages = 8;
            let startPage = tableActions[id].pager.page - 4;
            if (startPage < 1) startPage = 1;
            else if (tableActions[id].pager.page > 5) pages.push("1");
            for (let i = startPage; i <= startPage + 7; i++) {
                if (i < totalPages) pages.push(i);
            }
            pages.push(totalPages);
        } else {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        }
    }

    return (
        <>
            <div id={id} class={"table-container table-responsive" + (filter && filter.filterable && " has-filter")}>
                <table class={"bg-white table table-striped tableid-" + id} style="margin-bottom: 10px">
                    <caption class="ms-2">
                        {caption}
                    </caption>
                    <TableHead {...tableHeadProps} />
                    <TableBody {...tableBodyProps} />
                </table>
                {pagination &&
                    <nav aria-label="Page navigation">
                        <ul class="pagination ms-2">
                            {pages.length > 1 && Array.from(pages).map(page =>
                                <li class={tableActions[id].pager.page == page ? "page-item active" : "page-item"}><a class="page-link" href="#null" onClick={() => handlePageChange(page)} >{page}</a></li>
                            )}
                        </ul>
                    </nav>
                }
            </div>
            {filter && filter.filterable &&
                <div id="filter" class="filter position-fixed bottom-0 end-0 bg-white vw-100">
                    <div class="d-flex justify-content-between align-items-center mt-1 mb-1 ps-3">
                        <a class="results-counter" onDblClick={handleSelectAll}>{tableDataDisplay.nbResults[id]} résultat{tableDataDisplay.nbResults[id] > 1 && "s"}</a>
                        {tableActions[id].selectedRows && tableActions[id].selectedRows.length > 0 &&
                            <span class="selection">
                                {tableActions[id].selectedRows.length} sélection{tableActions[id].selectedRows.length > 1 && "s"} &nbsp;
                                <button class="action-button btn btn-secondary btn-sm" onDblClick={removeSelection}>X</button>
                            </span>
                        }
                        <input type="button" class="action-button btn btn-sm btn-primary me-3 p-2" id="toggleModalFilter" onClick={filter.toggleModal} value="Filtrer" />
                    </div>
                </div>
            }
        </>
    );
}